import { Route, Routes } from 'react-router-dom';

import { DixaMessengerApiProvider } from 'assets/components/settings/components/sections/dixaMessenger/api/apiProvider';

import { SettingsFlowAuditLogView } from '../flow/views/auditLog';

import { SettingsMessengerView } from './settingsMessenger.view';
import { SettingsMessengerEditBulletinView } from './views/editBulletin';
import { SettingsMessengerEditFlowView } from './views/editFlow';
import { MessengerSettingsView } from './views/messengerSettings';

const SettingsMessengerRoutes = (): JSX.Element => (
  <DixaMessengerApiProvider>
    <Routes>
      <Route index element={<SettingsMessengerView />} />
      <Route
        path="appearance/:messengerId"
        element={<MessengerSettingsView />}
      />
      <Route
        path="appearance/:messengerId/bulletin/:bulletinId"
        element={<SettingsMessengerEditBulletinView />}
      />
      <Route path="flow/:flowId" element={<SettingsMessengerEditFlowView />} />
      <Route
        path="flow/:flowId/history"
        element={<SettingsFlowAuditLogView channel="dixa-messenger" />}
      />
    </Routes>
  </DixaMessengerApiProvider>
);

export const settingsMessengerRoutes = (
  <Route path="dixa-messenger/*" element={<SettingsMessengerRoutes />} />
);
